export default "__VITE_ASSET__3PMY_$Ib__"